import { AnimatePresence, motion } from 'framer-motion'
import type { ReactNode } from 'react'

interface AnimatedTabContentProps {
    activeTab: string
    children: ReactNode
}

/**
 * Wraps tab content with a smooth fade + slide animation on tab switch.
 * Uses AnimatePresence with `mode="wait"` so the old tab fades out before the new one fades in.
 */
export function AnimatedTabContent({ activeTab, children }: AnimatedTabContentProps) {
    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.2, ease: 'easeInOut' }}
            >
                {children}
            </motion.div>
        </AnimatePresence>
    )
}
